export default __webpack_public_path__ + "static/media/restaurants.2389f6b3.svg";